//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AnimationDesigner.js";
import "../no/Builder.js";
import "../AnimationDesigner/AnimationDesigner.FlexibleCableAttachmentBuilderList.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"AttachmentList",0,"AnimationDesigner.FlexibleCableAttachmentBuilderList",0],[0,"AttachmentsReversed",1,0],[1,"Body",0,"SelectNXObject",0],[1,"Collisions",0,"SelectNXObjectList",0],[0,"Color",1,0],[0,"ColorOption",1,0],[1,"Curves",0,"SelectNXObjectList",0],[1,"Diameter",0,"Expression",0],[0,"GeometryType",1,0],[1,"Length",0,"Expression",0],[0,"Material",1,"AnimationDesigner.FlexibleMaterial",0],[0,"Name",1,0],[0,"SectionType",1,0],[1,"Thickness",0,"Expression",0],[1,"Width",0,"Expression",0]],[[["curveOrBodyUpdated"],"UpdateAttachmentData",{},1,0],[["points","widthDirections","radius","width","thickness"],"UpdatePreviewedCableFacet",{},5,0]],[]];
SPLM.AnimationDesigner.FlexibleCableBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AnimationDesigner.FlexibleCableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AnimationDesigner.FlexibleCableBuilder.SectionTypes = Object.freeze({
    "Circle" : "Circle", "Rectangle" : "Rectangle"});

SPLM.AnimationDesigner.FlexibleCableBuilder.GeometryTypes = Object.freeze({
    "Curve" : "Curve", "Body" : "Body", "Parameter" : "Parameter"});

SPLM.AnimationDesigner.FlexibleCableBuilder.ColorOptions = Object.freeze({
    "SpecifyColor" : "SpecifyColor", "NoColor" : "NoColor"});

export default SPLM;